"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Columns item component.
 *
 * This represents an individual list item that should be placed into a column.
 * In terms of HTML, this is the `<li>` element.
 *
 * @class Columns
 * @public
 */
class ColumnItem extends _react.Component {
  /**
   * Render the component.
   *
   * @returns {ReactElement} li
   * @api public
   */
  render() {
    const props = this.props;
    const className = (0, _classnames.default)(props.className, {
      selected: props.isSelected
    });
    return /*#__PURE__*/_react.default.createElement("li", {
      className: className
    }, this.props.children);
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
ColumnItem.propTypes = {
  isSelected: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
var _default = exports.default = ColumnItem;